// extracted by mini-css-extract-plugin
export var button = "styles-module--button--ab619";
export var buttonsContainer = "styles-module--buttonsContainer--7a814";
export var categoryButtonsSection = "styles-module--categoryButtonsSection--21473";
export var subtitle = "styles-module--subtitle--c77a5";
export var title = "styles-module--title--9ef62";